<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
        <v-card-text class="text-center">
          <v-avatar size="60" class="mb-4">
            <img src="@/assets/images/logo.svg" alt="" />
          </v-avatar>

          <h6 class="text--disabled font-weight-medium mb-10">
            {{ $t("auth.account_activation") }}
          </h6>

          <ca-alert v-show="alert.message" :type="alert.type">{{ alert.message }}</ca-alert>

          <p v-if="loading">{{ $t("auth.activation_in_progress") }}</p>

          <v-form>
            <div class="text-center">
              <v-btn text small color="primary" class="mb-2" :to="{ name: 'login' }">
                {{ $t("auth.sign_in") }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>

<script>
import CaAlert from "@/views/components/Alert";

export default {
  components: { CaAlert },
  metaInfo() {
    return {
      title: this.$t("titles.confirm_registration")
    };
  },
  data() {
    return {
      alert: {
        message: null,
        type: "warning"
      },
      show: false,
      loading: false
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    }
  },
  mounted() {
    this.restoreAccess();
  },
  methods: {
    restoreAccess() {
      this.loading = true;

      this.axios
        .post("auth/confirm-registration/" + this.token, {
          token: this.token
        })
        .then(response => {
          this.loading = false;

          if (response.data.success) {
            this.$router.push({ name: "login", query: { success: true } });
          } else {
            this.alert.message = this.$t("auth.invalid_token");
            this.alert.type = "warning";
          }
        })
        .catch(error => {
          this.loading = false;

          const response = error.response;

          if (response.status === 422) {
            this.alert.message = this.$t("auth.invalid_link");
            this.alert.type = "warning";
          }
        });
    }
  }
};
</script>
